/* eslint-disable react/require-default-props */
import React from 'react';
import {TouchableOpacity} from 'react-native';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {FEATURE_FLAGS_CONSTANT} from '/constant/featureFlag.constants';
import {Reports} from '/constant/TestIDs';
import {getDefaultNewCoachesKey} from '/util/filter.util';
import testProperties from '/util/testing/testProperties';
import {useFeatureFlag} from '/util/useFeatureFlag.util';

import {useClearMyTeamsFilters} from './hooks/useClearMyTeamsFilters';
import {TabFilters} from './types/MyTeamsFilters.types';
import {buildClearedFilters} from './util/resetFilters.util';
import styles from './ClearFilter.style';
import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';
interface ClearFilterProps {
  text?: string;
  filters: TabFilters;
  updateFilters: (updates: Partial<TabFilters>) => void;
  disabled?: boolean;
}

export const ClearFilter = ({
  text = '',
  filters,
  updateFilters,
  disabled = false,
}: ClearFilterProps) => {
  const ffTeamsOrgSR = useFeatureFlag(FEATURE_FLAGS_CONSTANT.TEAMS_ORG_SR);
  const defaultNewCoachesKey = getDefaultNewCoachesKey(ffTeamsOrgSR);

  const {isReadyToLoad} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });
  const clearMyTeamsFilters = useClearMyTeamsFilters();

  const handleClearFiltersPress = () => {
    updateFilters(buildClearedFilters(filters));
    clearMyTeamsFilters(defaultNewCoachesKey);
  };

  if (!isReadyToLoad) {
    return null;
  }

  return (
    <View
      style={[ffTeamsOrgSR ? styles.ffTeamsOrgSrContainer : styles.container]}>
      <TouchableOpacity
        onPress={handleClearFiltersPress}
        disabled={disabled}
        style={[
          ffTeamsOrgSR ? styles.ffTeamsOrgSrButton : styles.button,
          disabled && styles.disabled,
        ]}
        {...testProperties(Reports.reportFilterClearFiltersView, true)}>
        <View style={styles.buttonStyle}>
          <Text
            style={[
              ffTeamsOrgSR ? styles.ffTeamsOrgSrButtonText : styles.buttonText,
            ]}
            {...testProperties(Reports.reportFilterClearFiltersButton)}
            isBold>
            {text}
          </Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};
